import { render, staticRenderFns } from "./AccountSettingsChangePassword.vue?vue&type=template&id=450aad0a&scoped=true&"
import script from "./AccountSettingsChangePassword.vue?vue&type=script&lang=ts&"
export * from "./AccountSettingsChangePassword.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSettingsChangePassword.vue?vue&type=style&index=0&id=450aad0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450aad0a",
  null
  
)

export default component.exports